<template>
  <BaseLayoutApp>
    <div class="welcome">
      <div class="header">
        <div class="page-title">Welcome to Confetti</div>
        <div class="page-subtitle">Select a plan to get started</div>
      </div>
      <BasePlans />
    </div>
  </BaseLayoutApp>
</template>

<script>
import BaseLayoutApp from '@/components/BaseLayoutApp/BaseLayoutApp'
import BasePlans from '@/components/BasePlans/BasePlans'
export default {
  components: {
    BaseLayoutApp,
    BasePlans
  }
}
</script>

<style lang="scss" scoped>
.welcome {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.header {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.page-title {
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
  margin-bottom: var(--spacing-2);
}
.page-subtitle {
  color: var(--color-gray-3);
}
</style>
